import { watch, type ComputedRef } from 'vue'
import { useToast } from 'vue-toast-notification'

const useErrorToastWatcher = (
  success: ComputedRef<boolean>,
  message: ComputedRef<string | null | undefined>
) => {
  const toast = useToast()

  watch(
    () => message.value,
    (msg) => {
      if (!success.value && msg) {
        toast.error(msg, { position: 'top-right' })
      }
    }
  )
}

export default useErrorToastWatcher;